import { IconButton, SxProps, Theme } from "@mui/material";
import { ReactNode, CSSProperties } from "react";

interface IconProps {
  iconName?: string;
  icon?: ReactNode | string;
  onClick?: (() => void) | null;
  type?: "jsx" | "img";
  width?: string;
  height?: string;
  marginTop?: string;
  marginRight?: string;
  marginLeft?: string;
  [key: string]: any;
}

const Icon = ({
  iconName = "",
  icon,
  onClick = null,
  type = "jsx",
  width = "40px",
  height = "40px",
  marginTop = "",
  marginRight = "0px !important",
  marginLeft = "",
  ...props
}: IconProps) => {
  return type === "img" ? (
    <img
      alt={iconName}
      src={icon as string}
      style={
        {
          width: "50px",
          height: "50px",
          objectFit: "contain",
          ...props,
        } as CSSProperties
      }
    />
  ) : (
    <IconButton
      aria-label={iconName}
      onClick={onClick || undefined}
      sx={
        {
          ...props,
          width: width,
          height: height,
          marginRight: marginRight,
          marginTop: marginTop,
          marginLeft: marginLeft,
        } as SxProps<Theme>
      }>
      {icon}
    </IconButton>
  );
};

export default Icon;
